// src/components/Drive/DeliveryList/utils.js

export function toDateMaybe(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value.toDate();
  if (typeof value === "number") return new Date(value);
  if (typeof value === "string") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (value instanceof Date) return value;
  return null;
}

export function formatFi(date) {
  if (!date) return "—";
  return date.toLocaleString("fi-FI", { dateStyle: "short", timeStyle: "short" });
}

export function formatDistance(meters) {
  if (!meters || meters <= 0) return null;
  return meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`;
}

export function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return null;
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}

export function formatTimeLeft(pickupDate) {
  if (!pickupDate) return { label: null, urgency: "later" };
  const diffMs   = pickupDate.getTime() - Date.now();
  const diffMins = Math.round(diffMs / 60000);
  if (diffMins < 0)  return { label: "Myöhässä", urgency: "overdue" };
  if (diffMins < 30) return { label: `${diffMins} min`, urgency: "now" };
  if (diffMins < 90) return { label: `${diffMins} min`, urgency: "soon" };
  const diffH = Math.floor(diffMins / 60);
  const diffM = diffMins % 60;
  if (diffH < 24) return { label: diffM === 0 ? `${diffH} h` : `${diffH} h ${diffM} min`, urgency: "today" };
  return { label: formatFi(pickupDate), urgency: "later" };
}

export function haversineMeters(a, b) {
  const R      = 6371000;
  const toRad  = (x) => (x * Math.PI) / 180;
  const dLat   = toRad(b.lat - a.lat);
  const dLon   = toRad(b.long - a.long);
  const sinLat = Math.sin(dLat / 2);
  const sinLon = Math.sin(dLon / 2);
  const c      = sinLat * sinLat + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * sinLon * sinLon;
  return R * 2 * Math.atan2(Math.sqrt(c), Math.sqrt(1 - c));
}

export function getOriginCoords(delivery) {
  const c = delivery?.originInfo?.coordinates ?? delivery?.originCoordinates;
  if (!c) return null;
  const lat  = c.lat  ?? c.latitude;
  const long = c.long ?? c.lng ?? c.longitude;
  if (lat == null || long == null) return null;
  return { lat, long };
}

export const URGENCY_BORDER = {
  overdue: "error.main",
  now:     "error.main",
  soon:    "warning.main",
  today:   "info.main",
  later:   "divider",
};

export const URGENCY_CHIP = {
  overdue: { color: "error",   variant: "filled" },
  now:     { color: "error",   variant: "filled" },
  soon:    { color: "warning", variant: "filled" },
  today:   { color: "info",    variant: "filled" },
  later:   { color: "default", variant: "outlined" },
};
